export var preppQuery = function preppQuery(query, mapping) {
  return query && Object.keys(query).reduce(function (acc, curr) {
    if (mapping[curr]) {
      acc[mapping[curr]] = query[curr];
    }
    return acc;
  }, {});
};